import { jsPDF } from "jspdf";

export const drawPdfSectionHeading = (document: jsPDF, heading: string, y: number) => {
  document.setFont("helvetica", "bold");
  document.setFontSize(11);
  document.setTextColor(3, 125, 65);
  document.text(heading, 14, y);
  return y + 6;
};
